<template>
    <div class="related-symptom-list-container">

        <v-container grid-list-md class="no-padding-top">
            <v-layout row wrap>
                <v-flex  lg4 md6 sm12 v-for="symptom in selectedRelatedSymptomList" :key="symptom.code" >

                    <v-card :id="'v_card_' + symptom.code"
                            height="100%"
                            class="component-bg-color"
                            :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'SYMPTOMS_PANEL' && shortcutNav.crtSymptom === symptom.code)}"
                            @click.native="onSymptomPanelClick(symptom.code)">

                        <v-card-text class="px-0">

                            <question-list-block
                                :ref="'questionListBlockRef_' + symptom.code"
                                :questions="symptom.questionsData.questions"
                                :title="symptom.name"
                                :questionsCountAnswered="symptom.questionsData.countAnswered"
                                :questionsCountTotal="symptom.questionsData.countTotal"
                                titleClasses="symptom-name font-weight-bold font-size-medium text-transform-none"
                                :symptomCode="symptom.code"
                                @onProvideAnswer="handleProvideAnswer"
                                @emitQuestionClick="onQuestionClick"
                                :shortcutNav="shortcutNav">
                            </question-list-block>

                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import SymptomQuestionItem from "../../../../common/components/shared/SymptomQuestionItem";
    import { mapGetters } from 'vuex';
    import RadialProgressSvg from "../../../../common/components/svg/productList/radialProgress";
    import QuestionListBlock from "../../../../common/components/shared/QuestionListBlock";

    export default {
        name: 'SymptomsPanels',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock
        },

        props: ["shortcutNav"],

        computed: mapGetters({
            selectedRelatedSymptomList: 'SymptomsQuestionsStore/getSelectedRelatedSymptomList',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
        }),

        methods: {
            handleProvideAnswer(data) {
                this.$store.dispatch('SymptomsQuestionsStore/submitSpecificQuestionAnswer', data).then((response) => {
                    this.$emit('emitChangeAnswer', data);
                });
            },

            onQuestionClick(data) {

                data.crtPanel = "SYMPTOMS_PANEL";
                this.$emit('emitQuestionClick', data);
            },

            onSymptomPanelClick(symptomCode) {

                this.$emit('emitSymptomPanelClick', {symptomCode: symptomCode});
            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .symptom-column.flex {
        padding-right: 5px;
    }
    .break-text {
        word-break: break-all;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-panels/SymptomsPanels.vue